import { render } from "./Odontograma.vue?vue&type=template&id=45b848d4&scoped=true"
import script from "./Odontograma.vue?vue&type=script&lang=js"
export * from "./Odontograma.vue?vue&type=script&lang=js"

import "./Odontograma.vue?vue&type=style&index=0&id=45b848d4&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b848d4"]])

export default __exports__